
import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { ISiteNameWithId } from '~src/siteManagement/serverApi/types/ISiteNameWithId';
import { INamedItem } from '~src/spacesPlatform/models/resourceParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';
import { IView } from '~src/views/ServerApi/types/IView';

import { IAccelerationTask } from '../types/IAccelerationTask';

export interface IGetAccelerationTasksResult extends IGetItemsResult {
  tasks: IAccelerationTask[];
  workbooks: INamedItem[];
  users: IUser[];
  views: IView[];
  projects: INamedItem[];
  sites: ISiteNameWithId[];
}

export class GetAccelerationTasksRequest extends Request<IGetItemsParams, IGetAccelerationTasksResult> {
  constructor(params: IGetItemsParams) {
    super('getAccelerationTasks', params);
  }
}
